import { observer } from "mobx-react";
import { useEffect } from "react";
import { getTitle } from "utils";
import { OpportunityList } from "./components/OpportunityList";

export const QuotePage = observer(({ title = "" }: { title?: string }) => {
  useEffect(() => {
    document.title = getTitle(title);
  }, [title]);

  return <OpportunityList mode="quote" />;
});
